<script lang="ts" setup>
import { useRoute } from "vue-router";
import {
    IonPage,
    IonContent,
    IonNote,
    IonList,
    IonLabel,
    IonItem,
    IonRippleEffect,
    IonSpinner,
    IonButton,
    IonIcon,
    modalController,
} from "@ionic/vue";
import { pencilOutline } from "ionicons/icons";
import { ref, onMounted, computed, markRaw } from "vue";
import { useCostumersStore } from "@/stores/costumers"; // Adjust the import path as necessary
import BaseHeader from "@/components/BaseHeader.vue"; // Adjust the import path as necessary
import MapBox from "@/components/MapBox.vue"; // Adjust the import path as necessary
import { getColoredMarkerSvg, svgToDataUri } from "@/utility";
import { IExtendedMarkerOptions } from "@/types/maps";
import CostumerToZone from "@/components/modals/CostumerToZone.vue";
import ZoneForm from "@/components/modals/ZoneForm.vue";
import { HeaderButton } from "@/types/headerButton";

const route = useRoute();
const { zoneId } = route.params;
const costumerStore = useCostumersStore();
const isLoading = computed(() => costumerStore.isLoadingZones);
const zone = computed(() => costumerStore.getZoneById(Number(zoneId)));
const customers = computed(() => costumerStore.getCostumerByZone(Number(zoneId)));
const markers = ref<IExtendedMarkerOptions[]>([]);
const headerButtons = ref([
    {
        id: 1,
        label: "Assegna Clienti",
        action: async () => {
            const modal = await modalController.create({
                component: CostumerToZone,
                componentProps: {
                    zone: markRaw(zone.value as Object),
                },
            });
            modal.present();

            const result = await modal.onWillDismiss();
            if (result.role === "confirm") {
            }
        },
    } as HeaderButton,
]);
const loadZoneMarkers = () => {
    customers.value.forEach((customer) => {
        markers.value.push({
            position: {
                lat: Number(customer.latitude!),
                lng: Number(customer.longitude!),
            },
            icon: svgToDataUri(getColoredMarkerSvg(zone.value?.color ?? "#FFFFFF")), // Default color if not specified
            title: customer.business_name,
            clickable: true,
            infoWindowHTML: `<p>Ultima ispezione: ${customer.last_inspection_delta} giorni fa</p>`,
        } as IExtendedMarkerOptions);
    });
};

const openZoneForm = async () => {
    const modal = await modalController.create({
        component: ZoneForm,
        componentProps: {
            zone: markRaw(zone.value as Object),
        },
    });
    modal.present();

    const result = await modal.onWillDismiss();
    if (result.role === "confirm") {
        markers.value = [];
        loadZoneMarkers();
    }
};

onMounted(() => {
    loadZoneMarkers();
});
</script>
<template>
    <ion-page>
        <base-header :title="zone?.name" :buttons="headerButtons"></base-header>
        <ion-content :fullscreen="true">
            <ion-spinner v-if="isLoading" name="crescent"></ion-spinner>
            <div v-if="!isLoading" class="ion-padding-top ion-padding-horizontal" style="margin-bottom: 10px">
                <!-- @vue-ignore -->
                <map-box ref="mapBox" :max-zoom="18" :markers-data="markers" :disable-interactions="true"></map-box>
            </div>
            <template v-if="!isLoading">
                <div style="display: flex; justify-content: space-between; align-items: center" class="ion-padding">
                    <div>
                        <h2 style="margin-top: 0; font-weight: bold">{{ zone?.name }}</h2>
                        <h4 style="display: inline">Clienti nella area</h4>
                        <ion-note style="display: block; margin-bottom: 12px">Totale {{ customers.length }}</ion-note>
                    </div>
                    <ion-button
                        id="edit-zone-button"
                        style="font-size: 18px; --border-color: white; color: white"
                        fill="outline"
                        size="small"
                        @click="openZoneForm">
                        Modifica
                        <ion-icon slot="end" :icon="pencilOutline"></ion-icon>
                    </ion-button>
                </div>
                <ion-list class="">
                    <ion-item
                        v-for="customer in customers"
                        :key="customer.id"
                        @click="$router.push({ name: 'costumerDetails', params: { costumerId: customer.id } })">
                        <ion-label>
                            <h4 style="margin-bottom: 4px; margin-top: 0">{{ customer.business_name }}</h4>
                            <p style="margin-top: 0; margin-bottom: 4px">{{ customer.address }}</p>
                            <ion-note>Ultima ispezione: {{ customer.last_inspection_delta }} giorni fa</ion-note>
                        </ion-label>
                        <ion-ripple-effect></ion-ripple-effect>
                    </ion-item>
                </ion-list>
            </template>
        </ion-content>
    </ion-page>
</template>
